import { Fragment, useState } from "react";
import { Verified } from "@mui/icons-material";
import { Grid, InputAdornment } from "@mui/material";

import { useAxios } from "../../../hooks";
import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormOne({ brandID, editState, formikProps }) {
  const axios = useAxios();
  const [loading, setLoading] = useState(false);

  return (
    <Fragment>
      <Grid size={6}>
        <TextField
          size="small"
          label="Company GST Number"
          name="companyGSTNumber"
          placeholder="Company GST Number"
          formikProps={formikProps}
          disabled={!editState}
          InputProps={{
            endAdornment: (
              <InputAdornment position={"end"}>
                {formikProps.values.gstVerified &&
                formikProps.values.companyGSTNumber ? (
                  <Verified style={{ color: colors.green }} />
                ) : (
                  <PrimaryLoadingButton
                    loading={loading}
                    onClick={verifyGST}
                    style={{ height: "30px" }}
                    size="small"
                    variant="contained"
                    disabled={
                      !editState ||
                      formikProps.values.companyGSTNumber?.length !== 15
                    }
                  >
                    Verify GST
                  </PrimaryLoadingButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          label="Company Name"
          name="companyName"
          disabled={!editState}
          placeholder="Company Name"
          formikProps={formikProps}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          label="Company Contact"
          name="companyContact"
          disabled={!editState}
          placeholder="Company Contact"
          formikProps={formikProps}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          label="Business Nature"
          name="companyNatureBusiness"
          placeholder="Business Nature"
          disabled={!editState}
          formikProps={formikProps}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          label="Company Director's Name"
          name="companyDirectorsName"
          disabled={!editState}
          placeholder="Company Director's Name"
          formikProps={formikProps}
        />
      </Grid>
    </Fragment>
  );

  function verifyGST() {
    setLoading(true);
    axios({
      url: "/get/gstDetail",
      method: "POST",
      disableRedirect: true,
      data: {
        gst_no: formikProps.values.companyGSTNumber,
        ...(!!brandID && { brand_id: parseInt(brandID) }),
      },
    }).then(function (response) {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          gstVerified: true,
          companyNatureBusiness: response.data.nature_of_business,
          companyName: response.data.company_name,
          companyAddress: response.data.address,
          companyDirectorsName: response.data.director_name,
        }));
      }
      setLoading(false);
    });
  }
}
